import { render, staticRenderFns } from "./empleados.vue?vue&type=template&id=20ea89d2&scoped=true"
import script from "./empleados.vue?vue&type=script&lang=js"
export * from "./empleados.vue?vue&type=script&lang=js"
import style0 from "./empleados.vue?vue&type=style&index=0&id=20ea89d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea89d2",
  null
  
)

export default component.exports